<div class="mat-elevation-z6 landing-container">
  <div fxLayout.gt-sm="row" fxLayout.lt-md="column" fxLayoutAlign="space-between center">
    <div class="padding-16" fxFlex.gt-sm="70" fxFlex.lt-md="100">
      <div class="mat-title"><strong>Booking</strong><span class="light">App</span></div>
      <div class="mat-body-2 padding-topBottom-8" style="font-size: 16px">
        Dragi studenți, începând cu data de 3 octombrie 2026 aplicația rezervari.upt.ro intră în proces de retragere din utilizare, iar rezervarile vor putea fi realizate de pe platforma student.upt.ro, începând cu săptămâna 12-18 octombrie.
<br>
        La nivelul căminelor au fost rugați administratorii și comitetele de cămin să asigure rezervări pe suport de hârtie pentru perioada aceasta de tranziție.
<br>
        Rezervările pentru săptămâna 5-11 octombrie la bazele sportive rămân valabile.
<br>
        Mulțumim pentru înțelegere și cooperare!
      </div>
      <br />
      <div>
        <div>
          <img class="logo img-responsive" src="/assets/images/cospol.png" />
        </div>
        <div>
          <img class="logo-small img-responsive" src="/assets/images/a4.png" />
          <img class="logo-small img-responsive" src="/assets/images/ligaac.png" />
          <img class="logo-small img-responsive" src="/assets/images/lsct.png" />
          <img class="logo-small img-responsive" src="/assets/images/lsfee.png" />
          <img class="logo-small img-responsive" src="/assets/images/lsfetc.png" />
          <img class="logo-small img-responsive" src="/assets/images/lsfmpt.png" />
          <img class="logo-small img-responsive" src="/assets/images/lsfmt.png" />
          <img class="logo-small img-responsive" src="/assets/images/ostl.png" />
        </div>
      </div>

      <div class="padding-topBottom-8">
        <small
          >Versiune: <b>{{ constants.version }}</b></small
        >
      </div>
    </div>
    <img
      fxFlex
      fxShow.lt-md="false"
      fxFlexAlign="center"
      class="poli-img"
      src="/assets/images/politehnica.jpg"
    />
  </div>
</div>
